<template>
  <div class="row">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InfoRow'
}
</script>

<style scoped>
.row {
  height: 72px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(9, 21, 64, 0.08);
}
</style>
